import { connect } from 'react-redux';
import { get } from 'lodash-es';
import { byBaseUrl } from 'core/runtimeConfigReducer';
import PropertyList from '../PropertyList';
import {
  byIsLoading,
  byCommercialHits,
  byResidentialHits,
  byCompanyName,
  byVacationHitGroups,
} from '../selectors';

const mapStateToProps = (state: any) => ({
  baseUrl: byBaseUrl(state),
  commercialHits: byCommercialHits(state),
  companyName: byCompanyName(state),
  isLoading: byIsLoading(state),
  residentialHits: byResidentialHits(state),
  vacationHitGroups: byVacationHitGroups(state),
  cwid: get(state, 'expose.view.cwid'),
});

const PropertyListContainer = connect(mapStateToProps)(PropertyList);

export default PropertyListContainer;
